import React from "react";
import { Steps as ProgressBar } from "antd";
import { Link } from "react-router-dom";
import { ReactComponent as ActiveIcon } from "./../../assets/icons/Group 662.svg";
import { ReactComponent as WaitIcon } from "./../../assets/icons/Group 663.svg";
import { ReactComponent as DoneIcon } from "./../../assets/icons/done.svg";

const Steps = ({ current, onChange }) => {
  return (
    <>
      <div className="bg-primaryShadedBlue w-3/6 h-60 p-6 rounded-5xl 2xl:h-90 2xl:flex 2xl:flex-col 2xl:justify-center">
        <ProgressBar
          className="steps-component h-60 2xl:h-90"
          current={current}
          direction="vertical"
          items={[
            {
              title: (
                <Link to="" className="text-black hover:text-grey">
                  Create Account
                </Link>
              ),
              description: (
                <Link to="" className="text-black hover:text-grey">
                  Please Enter Your Business & Contact Information
                </Link>
              ),
              icon: (
                <Link to="">
                  {current === 0 ? <ActiveIcon /> : <DoneIcon />}
                </Link>
              ),
            },

            {
              title: (
                <Link to="" className="text-black hover:text-grey">
                  Invite Team Members
                </Link>
              ),
              description: (
                <Link to="" className="text-black hover:text-grey">
                  Invite Your Staff To Use The Business Account To Manage Orders
                </Link>
              ),
              icon: (
                <Link to="">
                  {current === 2 ? (
                    <ActiveIcon />
                  ) : current > 2 ? (
                    <DoneIcon />
                  ) : (
                    <WaitIcon />
                  )}
                </Link>
              ),
            },
            {
              title: (
                <Link to="" className="text-black hover:text-grey">
                  Add Deals
                </Link>
              ),
              description: (
                <Link to="" className="text-black hover:text-grey">
                  Add Your Deals
                </Link>
              ),
              icon: (
                <Link to="">
                  {current === 3 ? (
                    <ActiveIcon />
                  ) : current > 3 ? (
                    <DoneIcon />
                  ) : (
                    <WaitIcon />
                  )}
                </Link>
              ),
            },
            {
              title: (
                <Link to="" className="text-black hover:text-grey">
                  Pay
                </Link>
              ),
              description: (
                <Link to="" className="text-black hover:text-grey">
                  Pay Your YupUp Setup cost to become a YupUp Vendor
                </Link>
              ),
              icon: (
                <Link to="">
                  {current === 4 ? (
                    <ActiveIcon />
                  ) : current > 4 ? (
                    <DoneIcon />
                  ) : (
                    <WaitIcon />
                  )}
                </Link>
              ),
            },
          ]}
          onChange={onChange}
        />
      </div>
    </>
  );
};

export default Steps;
